<template>
  <v-container class="fill-height" fluid>
    <v-row v-if="isStudent">
      <v-col cols="12" sm="6" class="text-center">
        <img
          :src="images.jaceyUwill"
          style="margin-top:44px;"
          alt="Uwill"
          :style="
            $vuetify.display.smAndUp ? 'max-width:560px;' : 'max-width:300px;'
          "
        />
      </v-col>
      <v-col cols="12" sm="6" order="first" order-sm="last">
        <v-row style="margin-top: 5%;">
          <h1 class="section-title-large pb-6">
            Welcome to Uwill!
          </h1>
        </v-row>
        <v-row>
          <div class="mt-6" style="text-align: left; font-size: 14px;">
            We sent an email to <strong>{{ $store.state.user.email }}</strong>. <br /><br />
            Check your email to verify and activate your account. <br />
            <i>If you don’t see it soon, check your junk/spam folder.</i>
          </div>
        </v-row>
        <v-row class="mt-16">
          <v-btn variant="text" @click="resendConfirmation()" class="uwill-primary-button outline">
            Resend the activation email
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-else align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="mx-auto" border>
          <v-list-item lines="three">
            <div class="text-overline mb-4">Waiting for verification...</div>
            <v-list-item-title class="text-h5 mb-1">
              Activate your account
            </v-list-item-title>
            <v-list-item-subtitle>
              We sent an email to
              <span class="font-italic font-weight-bold">{{
                $store.state.user.email
              }}</span
              >.
            </v-list-item-subtitle>
            <v-list-item-subtitle class="mt-2 mb-2">
              Please check your email to verify and activate your account.
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              If you don't see it soon, please make sure to
              <em>check your junk/spam folder</em>.
            </v-list-item-subtitle>
          </v-list-item>

          <v-card-actions>
            <v-btn variant="text" @click="resendConfirmation()">
              Resend the activation email
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "Confirmation",
  props: ["isStudent"],
  data: () => ({
    confirmed: false,
    images: {
      jaceyUwill: require("@/assets/images/jacey_uwill.png")
    }
  }),
  methods: {
    resendConfirmation: function() {
      new Promise(resolve => {
        axios({
          method: "post",
          url: "/resendconfirmation"
        }).then(resp => {
          window.Bus.$emit("flash-message", {
            text: resp.data.message
          });
          resolve();
        });
      });
    }
  }
};
</script>
